module.exports = __webpack_public_path__ + "img/Jump Screenshoot (0-00-09-06)_25.4b9ad05c.jpg";